import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { DeployerRelaysEndpointMethod } from '../../deployerGrid/types';
import { DeployerGridResponses, UpdateServerLocationResponse } from '../../deployerGrid/types/deployer-grid-responses';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';

export abstract class PackageDeployerFormBaseDataProvider extends BaseWebComponentDataProvider {
  public async getSuperAgentsForCompany(companyId: string | undefined): Promise<DeployerGridResponses> {
    return (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        companyId: companyId,
        page: 1,
        limit: 100,
      },
      endpoint: 'ProtectedEntities',
      method: DeployerRelaysEndpointMethod.GET_SUPER_AGENTS,
    })) as DeployerGridResponses;
  }

  public async getUpdateServerLocation(): Promise<UpdateServerLocationResponse> {
    return (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Packages',
      method: DeployerRelaysEndpointMethod.GET_UPDATE_SERVER_LOCATION,
    })) as UpdateServerLocationResponse;
  }
}
